import React, { FC } from 'react';
import { SrWidget } from './SrWidget';

export interface SrWidgetSeasonTopListsProps extends React.HTMLAttributes<HTMLDivElement> {
    matchId: string;
}

export const SrWidgetSeasonTopLists: FC<SrWidgetSeasonTopListsProps> = ({ matchId, ...props }) => {
    const widgetProps = {
        matchId
    };
    return <SrWidget widgetName="season.topLists" widgetProps={widgetProps} {...props} />;
};
